import axios from "./axios";

export const getBillingData = (token) => {
  return axios.post(
    "/billing/all-invoices",
    {},
    {
      headers: {
        "API-TOKEN": token,
      },
    }
  );
};

export const sendRefundRequest = (token, params) => {
  return axios.post("/request-refund", params, {
    headers: {
      "API-TOKEN": token,
    },
  });
};
